import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import { useAuthContext } from './hooks/useAuthContext'



// pages & components
import Home from './pages/home/Home'
import Login from './pages/login/Login'
import Signup from './pages/signup/Signup'
import Navbar from './components/Navbar'
import StudentsList from './pages/students/StudentsList'
import { ToastContainer, toast } from 'react-toastify';
import { includesNumber } from './utils/includeNumber'
import 'react-toastify/dist/ReactToastify.css';
import Underwork from './pages/underwork'
import { useCollection } from './hooks/useCollection'
import { useEffect, useState } from 'react'
import { projectFirestore } from './firebase/config'
import Chatbot from './components/Chatbot'

function App() {
  const { authIsReady, user } = useAuthContext()
  const [portalStatus, setPortalStatus] = useState('');
  const [portalMessage, setPortalMessage] = useState('');

  useEffect(() => {
    const unsubscribe = projectFirestore.collection('portal_control')
      .doc('registration_status') // Replace with your specific document ID
      .onSnapshot(doc => {
        if (doc.exists) {
          setPortalStatus(doc.data().portal_status);
          setPortalMessage(doc.data().message);

        } else {
          console.log('No such document!');
        }
      }, err => {
        console.log(err);
      });

    return () => unsubscribe();
  }, []);

  if (portalStatus === 'CLOSED') {
    return <Underwork message={portalMessage} />;
  }

  return (
  <div className="App">
<ToastContainer/>
{authIsReady && (
  <BrowserRouter>
    <Route
      render={({ location }) =>
        location.pathname !== "/login" && <Navbar />
      }
    />
    <Switch>
      <Route exact path="/">
        {!user && <Redirect to="/login" />}
        {user && includesNumber(user.email) && <Home  portalStatus={portalStatus}/>}
        {user && !includesNumber(user.email) && <Redirect to="/Students" />}
      </Route>
      <Route exact path="/Students">
        {!user && <Redirect to="/login" />}
        {user && !includesNumber(user.email) && <StudentsList />}
        {user && includesNumber(user.email) && <Redirect to="/" />}
      </Route>
      <Route path="/login">
        {user && <Redirect to="/" />}
        {!user && <Login />}
      </Route>
    </Switch>
  </BrowserRouter>
)}

    </div>
  );
}

export default App